class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    if (this.dataset.defaultCollection && !FacetFiltersForm.tabData.find(t => t.handle === this.dataset.defaultCollection)) {
      FacetFiltersForm.tabData = [...FacetFiltersForm.tabData, {
        handle: this.dataset.defaultCollection,
        html: document.documentElement.outerHTML
      }];
    }

    const facetForm = this.querySelector('form');

    facetForm.addEventListener('input', this.onSubmitHandler.bind(this));
  }

  static setListeners() {
    const title = document.querySelector('h1');
    const tabs = document.querySelectorAll('.collection__tab');
    const filters = document.querySelector('.collection__filters');
    const breadcrumbs = document.querySelector('.breadcrumbs__list [aria-current="page"]');

    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    const triggerFilters = (method, event) => {
      event.preventDefault();

      if (!filters) return;

      filters.classList[method]('collection__filters--active');
    };
    const collectionTab = async (tab, event) => {
      event.preventDefault();

      const text = tab.dataset.text;
      const handle = tab.dataset.handle;
      const breadcrumbsText = tab.dataset.breadcrumbsText;

      if (FacetFiltersForm.tabData.some(t => t.handle === handle)) {
        const html = FacetFiltersForm.tabData.find(t => t.handle === handle).html;

        this.renderFilters(html);
        this.renderProductGridContainer(html);
        this.renderProductCount(html);
      } else {
        tab.classList.add('loading');

        const html = await fetch(`/collections/${ handle }`).then(res => res.text());

        FacetFiltersForm.tabData = [...FacetFiltersForm.tabData, { handle, html }];
        this.renderFilters(html);
        this.renderProductGridContainer(html);
        this.renderProductCount(html);

        tab.classList.remove('loading');
      }

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      breadcrumbs.innerText = breadcrumbsText;

      title.innerText = text;
      history.pushState(null, text, handle);
    };

    document.addEventListener('DOMContentLoaded', () => {
      const tabActive = document.querySelector('.collection__tab.active');

      if (tabActive) {
        breadcrumbs.innerText = tabActive.dataset.breadcrumbsText;
      }

      setTimeout(() => document.querySelector('section.collection')?.classList.add('collection--ready'), 300);
    });

    window.addEventListener('popstate', onHistoryChange);
    tabs.forEach(tab => tab.addEventListener('click', event => collectionTab(tab, event)));
    document.querySelector('.collection__button--filters')?.addEventListener('click', event => triggerFilters('add', event));
    document.querySelector('.collection__icon--cross')?.addEventListener('click', event => triggerFilters('remove', event));
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');

    container.innerHTML = count;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelector('#FacetFiltersForm');
    const facetDetailsElementsFromDom = document.querySelector('#FacetFiltersForm');

    facetDetailsElementsFromDom.innerHTML = facetDetailsElementsFromFetch.innerHTML;
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderAdditionalElements(html) {
    const additionalElements = ['.sorting'];

    additionalElements.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    const target = event.target.closest('label');

    event.preventDefault();

    if (target) {
      target.classList.add('loading');
    }

    const forms = [];
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.tabData = [];
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
